import React from "react";

import { FillIssuePicker } from "#app/components/forms/form-fill/fill-issue-picker";
import { FormFillDialog } from "#app/components/forms/form-fill/form-fill-dialog";
import type { IssueRow } from "#app/lib/data";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

export type FormFillIssue = Pick<
  IssueRow,
  "issueId" | "values" | "issueTypeId" | "workflowId" | "stageId" | "name" | "viewerCanEdit"
> &
  Partial<Pick<IssueRow, "address" | "assignees" | "description" | "issueSourceId" | "teams">>;

export type FormFillTarget =
  | { kind: "submission"; submissionId: string; issueId: string }
  | { kind: "new"; formId: string; issue: FormFillIssue };

export type FormFillRequest =
  | FormFillTarget
  | { kind: "pickIssue"; formId: string; formName: string };

type FormFillDialogActions = {
  open: (request: FormFillRequest) => void;
};

const formFillDialog = createDialogEmitter<FormFillRequest>("form_fill");

const FORM_FILL_ACTIONS: FormFillDialogActions = { open: formFillDialog.open };

export function useFormFillDialogActions(): FormFillDialogActions {
  return FORM_FILL_ACTIONS;
}

export function FormFillDialogMount() {
  const { open: isOpen, payload } = formFillDialog.useDialogState();
  const request = isOpen ? payload : null;

  const picking = request?.kind === "pickIssue" ? request : null;
  const target = request && request.kind !== "pickIssue" ? request : null;
  // The last target survives close so the closing sheet keeps its filling.
  const [shown, setShown] = React.useState(target);
  if (target && target !== shown) setShown(target);

  return (
    <>
      <FormFillDialog
        onClose={formFillDialog.close}
        open={target !== null}
        target={target ?? shown}
      />
      <FillIssuePicker
        formId={picking?.formId ?? null}
        formName={picking?.formName ?? ""}
        onOpenChange={(open) => {
          if (!open) formFillDialog.close();
        }}
        onPick={(issue) => {
          if (picking) formFillDialog.open({ formId: picking.formId, issue, kind: "new" });
        }}
        open={picking !== null}
      />
    </>
  );
}
